<template>
  <div class="tiles-grid">
    <div v-for="(gridItems, i) in chunkedItems" :key="`item-row-${i}`" class="tiles-row">
      <div v-for="(item, j) in gridItems" :key="`item-${i}-${j}`" class="tiles-col">
        <slot :item="item"></slot>
      </div>
    </div>
  </div>
</template>
<script>
import _ from "lodash";
import { isMobile } from "../../mixins/is-mobile";

export default {
  name: "Tiles",
  props: {
    items: { type: Array, default: () => [] }
  },
  mixins: [isMobile],

  computed: {
    chunkedItems: function() {
      let chunk = 4;
      if (this.isTablet) chunk = 2;
      if (this.isMobile) chunk = 1;
      return _.chunk(this.items, chunk);
    }
  }
};
</script>
<style lang="scss">
.tiles-row {
  display: flex;
  margin-bottom: 20px;

  .tiles-col {
    width: calc(25% - 15px);
    margin-right: 20px;
    &:last-child {
      margin-right: 0;
    }
  }
}

.tiles-item {
  background: #fff;
  height: 100%;
  box-shadow: 0 0 30px rgba(0, 0, 0, 0.16);
  border-radius: 30px;
  overflow: hidden;
  position: relative;
  cursor: pointer;

  .media-div {
    width: 100%;
    height: 100%;

    .media-div__inner {
      width: 100%;
      height: 100%;
    }
  }

  .custom-button {
    z-index: 1;
    position: absolute;
    left: 50%;
    bottom: 15px;
    transform: translateX(-50%);
    letter-spacing: 2.37px;
    width: 90%;
    color: #2c255e;
    box-shadow: 0 3px 20px rgba(0, 0, 0, 0.16);
    display: block;
    text-align: center;
    font-family: "Montserrat", sans-serif;
  }
}

@media (max-width: 890px) {
  .tiles-row {
    .tiles-col {
      width: calc(50% - 20px);
      margin-right: 20px;
      &:last-child {
        margin-right: 0;
      }
    }
  }
}

@media (max-width: 600px) {
  .tiles-row {
    .tiles-col {
      width: 100%;
      margin-right: 0;
    }
    &::before {
      content: none;
    }
  }

  .tiles-item {
    background: none;
    box-shadow: none;
    overflow: inherit;
    .custom-button {
      position: relative;
      left: 0;
      transform: none;
      margin: 0 auto;
    }
  }
}
</style>